import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../services/firebase";
import { useAuth } from "../contexts/AuthContext";
import BlogCard from "../components/Blog/BlogCard";
import SearchFilter from "../components/Blog/SearchFilter";
 

const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 3rem 2rem;
  position: relative;
  z-index: 1;
`;

const PageHeader = styled.div`
  margin-bottom: 3rem;
  text-align: center;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
`;

const Description = styled.p`
  font-size: 1.25rem;
  color: var(--color-text-light);
  font-family: var(--font-subheading);
  line-height: 1.6;
  font-style: italic;
`;

const NewPostButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: var(--color-accent);
  color: white;
  border-radius: 50%;
  font-weight: 500;
  margin: 0 auto 2rem auto;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(199, 54, 89, 0.3);

  &:hover {
    background: var(--color-accent-hover);
    text-decoration: none;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(199, 54, 89, 0.4);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

const PostList = styled.div`
  margin-top: 3rem;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 0;
  color: var(--color-text-light);
`;

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthorized } = useAuth();

  useEffect(() => {
    const q = query(collection(db, "posts"), orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const postsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPosts(postsData);
      setFilteredPosts(postsData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <>
      <Container>
        <PageHeader>
          <Title>Monologues</Title>
          <Description>
            Thoughts on anthropology, identity, society, and the human
            experience
          </Description>
        </PageHeader>

        {isAuthorized && (
          <NewPostButton to="/admin/new-post" title="Create New Post">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <title>Create New Post</title>
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </NewPostButton>
        )}

        <SearchFilter posts={posts} onFilterChange={setFilteredPosts} />

        <PostList>
          {loading ? (
            <EmptyState>Loading posts...</EmptyState>
          ) : filteredPosts.length === 0 ? (
            <EmptyState>No posts yet. Check back soon!</EmptyState>
          ) : (
            filteredPosts.map((post) => <BlogCard key={post.id} post={post} />)
          )}
        </PostList>
      </Container>
    </>
  );
};

export default Blog;
